module.exports = __webpack_public_path__ + "img/arrow-select.9bca2e68.svg";